module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_f-b5565de1709b4045e77c8989cf778df0.png";